import styled from '@emotion/styled';

import theme from '../../constants/theme';

export const Wrapper = styled.div`
  position: absolute;
  z-index: 1010;
  text-align: left;
  background-color: ${theme.colors.pureWhite};
  white-space: normal;
  width: 100%;
  max-width: 376px;
  border: 1px solid #ddd;
  border-right: 0;
  top: 60px;
  right: 0;
  padding: 15px 25px;
  line-height: 1.15;

  ul {
    margin: 0;
    padding: 0;
    list-style-position: outside;
    list-style-image: none;
  }
`;

export const Header = styled.div`
  :after {
    content: '';
    border-bottom: 1px solid #d9d9d9;
    display: block;
    margin: 15px 0;
  }
`;

export const LoginButton = styled.a`
  display: block;
  text-align: center;
  cursor: pointer;
  margin: 5px 0 10px;
  padding: 0.5rem 0.875rem;
  line-height: 1.5;
  font-weight: 500;
  background-color: ${theme.colors.primaryBlue};
  color: ${theme.colors.pureWhite};

  &:hover,
  &:active,
  &:focus {
    opacity: 0.8;
    transition: all 0.4s ease;
    color: ${theme.colors.pureWhite};
  }
`;

export const FirstLastName = styled.div`
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 8px;
`;

export const UserEmail = styled.div`
  font-size: 14px;
`;

export const LogOutInfo = styled.div`
  width: 100%;
  text-align: left;
  :before {
    content: '';
    border-top: 1px solid #d9d9d9;
    display: block;
    margin: 15px 0;
  }
`;

export default {
  Wrapper,
  Header,
  LoginButton,
  FirstLastName,
  UserEmail,
  LogOutInfo,
};
